import cx from 'classnames';
import { useContext } from 'react';
import ModalContext from '~/context/srp/ModalContext';

type OwnProps = {
  isFixed: boolean;
};

export default function BackgroundOverlay({ isFixed }: OwnProps) {
  const { isSearchBarFocused } = useContext(ModalContext);

  return (
    <div
      aria-hidden="true"
      className={cx(
        'pointer-events-none top-0 z-10 h-dvh w-screen bg-canvas-overlay transition-all duration-300',
        isFixed ? 'fixed left-0' : 'absolute left-1/2 -translate-x-1/2',
        isSearchBarFocused ? 'opacity-100' : 'opacity-0'
      )}
    />
  );
}
